
import { Component, Vue } from "vue-property-decorator";
import store from "@/store/index";
import Controller from "@/core/controller/Controller";
import { MapItem } from "@/core/mapitems/map-item";

@Component
export default class ToolZone extends Vue {
  get available(): boolean {
    const m = store.state.module1;
    return m.currentMode === "LAYOUT" && m.panelCurrentItem != null;
  }
  length = 50;
  get currentItem(): MapItem | null {
    return store.state.module1.panelCurrentItem;
  }
  rotate() {
    if (this.available && this.currentItem) {
      Controller.getInstance().handleRotate(this.currentItem.id);
    }
  }
  remove() {
    if (this.available && this.currentItem) {
      Controller.getInstance().handleDeleteItem(this.currentItem.id);
    }
  }
  zoomin() {
    if (this.available && this.currentItem) {
      Controller.getInstance().handleZoomIn(this.currentItem.id);
    }
  }
  zoomout() {
    if (this.available && this.currentItem) {
      Controller.getInstance().handleZoomOut(this.currentItem.id);
    }
  }
}
